import { MCP_WIDGET_CONTEXT_TOOLS, MCP_WIDGET_META_KEY } from "../../constant/mcpWidget";
import { widgetHost } from "./widgetHost";

export const withoutUserId = <T extends Record<string, unknown>>({ userId, ...body }: T): Omit<T, "userId"> => body;

export const callWidgetTool = async (
  name: string,
  args: Record<string, unknown>,
  signal?: AbortSignal
): Promise<unknown> => {
  const app = widgetHost()?.app;
  if (!app) return null;
  const result = await app.callServerTool({ name, arguments: args }, { signal }).catch(() => null);
  const data = result?._meta?.[MCP_WIDGET_META_KEY];
  if (!result || result.isError || !data || typeof data !== "object" || !("response" in data)) return null;
  if (MCP_WIDGET_CONTEXT_TOOLS.includes(name)) {
    app.updateModelContext({ content: result.content }).catch(() => undefined);
  }
  return (data as { response: unknown }).response;
};
